exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.calculable-items-container[data-v-97a6e25a] {\n    margin-bottom: 20px;\n}\n", ""]);

// exports
